/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The configured-action order as committed.
 * @export
 * @interface ActionReorderResponse
 */
export interface ActionReorderResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionReorderResponse
     */
    actionIds: Array<string>;
}

/**
 * Check if a given object implements the ActionReorderResponse interface.
 */
export function instanceOfActionReorderResponse(value: object): value is ActionReorderResponse {
    if ((!('actionIds' in (value as Record<string, any>)) && !('action_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionIds'] === undefined && (value as Record<string, any>)['action_ids'] === undefined)) return false;
    return true;
}

export function ActionReorderResponseFromJSON(json: any): ActionReorderResponse {
    return ActionReorderResponseFromJSONTyped(json, false);
}

export function ActionReorderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionReorderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'actionIds': json['action_ids'],
    };
}

export function ActionReorderResponseToJSON(json: any): ActionReorderResponse {
    return ActionReorderResponseToJSONTyped(json, false);
}

export function ActionReorderResponseToJSONTyped(value?: ActionReorderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action_ids': value['actionIds'],
    };
}

